import { formatTitleDateRange, isPastEvent } from 'app/utilities/date-time';

/**
 * Event document title before site-name suffix.
 * Past: "Past Event | {name}"
 * Upcoming: "{name} | {dates}" when dates exist, otherwise "{name}"
 *
 * @param {string} name
 * @param {string} startDate
 * @param {string} endDate
 * @return {string}
 */
export function getEventPageTitle(name, startDate, endDate) {
    if (!name) {
        return name;
    }

    if (isPastEvent(endDate)) {
        return `Past Event | ${name}`;
    }

    const titleDate = formatTitleDateRange(startDate, endDate);

    if (titleDate) {
        return `${name} | ${titleDate}`;
    }

    return name;
}
